import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {InlineLinkButton} from '../../../../../libs/shared/ui/src/components/buttons/inlineLinkButton';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {findThemedImageInfo, ThemedImageNamesEnum} from '../../../../helpers/imageThemeHelpers';
import {SearchNoResultsHeader} from './searchNoResultsHeader';
import {
  maybeTruncateAndAddQuotes,
  SEARCH_NO_RESULTS_MAX_CHARS_QUERY,
  StyledNoResultsFooterContentDiv,
  StyledNoResultsFooterDiv,
  StyledNoResultsWrapperDiv,
} from './searchNoResultsMessage';

/*
 * Props.
 */

interface SearchNoResultsNegationMisuseProps {
  originalQuery: string;
  queryWithWrappedNegatedTerms: string;
  searchWithWrappedNegatedTerms: () => void;
}

/*
 * Component.
 */

export const SearchNoResultsNegationMisuse: FC<SearchNoResultsNegationMisuseProps> = (props) => {
  const {originalQuery, queryWithWrappedNegatedTerms, searchWithWrappedNegatedTerms} = props;

  const theme = useUserTheme();
  const searchNoResultsAnywhere = findThemedImageInfo(theme, ThemedImageNamesEnum.SEARCH_NO_RESULTS_ANYWHERE);

  const queryWithWrappedNegatedTermsCta = (
    <InlineLinkButton
      interactionId="search-invalid-negated-terms-usage-nudge-cta"
      onClick={searchWithWrappedNegatedTerms}
    >
      {queryWithWrappedNegatedTerms}
    </InlineLinkButton>
  );

  return (
    <StyledNoResultsWrapperDiv>
      <SearchNoResultsHeader
        image={searchNoResultsAnywhere.src}
        imageWidth={searchNoResultsAnywhere.width}
        imageHeight={searchNoResultsAnywhere.height}
      >
        {maybeTruncateAndAddQuotes(originalQuery, SEARCH_NO_RESULTS_MAX_CHARS_QUERY, true)}{' '}
        <Trans id="search-invalid-negated-terms-usage-title">is an invalid search.</Trans>
      </SearchNoResultsHeader>
      <StyledNoResultsFooterDiv>
        <StyledNoResultsFooterContentDiv>
          <Trans id="search-invalid-negated-terms-usage-explanation">
            We don&apos;t support searches that only contain excluding keywords.
            <br />
            Add another keyword that doesn&apos;t start with a minus (-) sign or search for an exact match{' '}
            {queryWithWrappedNegatedTermsCta}.
          </Trans>
        </StyledNoResultsFooterContentDiv>
      </StyledNoResultsFooterDiv>
    </StyledNoResultsWrapperDiv>
  );
};
